declare var moment: any;

export class DateRangeControl {
    public dateFrom: Date;
    public dateTo: Date;

    constructor(
        private $el: JQuery,
        private onChangeCallback: () => void,
        initialDateFrom: Date,
        initialDateTo: Date,
        maxDaysSpan: number,
        drops: "down" | "up" | "auto") {
        if ($el.length === 0) {
            throw new Error("invalid element");
        } 

        (this.$el as any).daterangepicker({
            startDate: moment(initialDateFrom),
            endDate: moment(initialDateTo),
            timePicker: true,
            alwaysShowCalendars: true,
            // if re-using these options in new scenarios, the start of day and end of day behaviour may need to be configured or adjusted. Midnight is intentionally chosen for date+time based filters
            ranges: {
               'Today': [moment().startOf("day"), moment()],
               'Yesterday': [moment().subtract(1, 'days').startOf("day"), moment().subtract(1, 'days').endOf("day")],
               'Last 3 Days': [moment().subtract(2, 'days').startOf("day"), moment()],
               'Last 7 Days': [moment().subtract(6, 'days').startOf("day"), moment()],
            },
            drops: drops,
            maxSpan: {
                "days": maxDaysSpan,
            }
        }, this.onDateRangeChange.bind(this));
        this.setDateRangeDisplay(moment(initialDateFrom), moment(initialDateTo));
        this.dateFrom = initialDateFrom;
        this.dateTo = initialDateTo;
    }

    public setDate(dateFrom: Date, dateTo: Date) {
        (this.$el as any).data('daterangepicker').setStartDate(dateFrom);
        (this.$el as any).data('daterangepicker').setEndDate(dateTo);
    }

    public destroy() {
        this.$el.off();
        delete this.$el;
        delete this.onChangeCallback;
    }

    /** start and end are moment instances. moment library not imported properly (in theme files) */
    private onDateRangeChange(start: any, end: any) {
        this.setDateRangeDisplay(start, end);
        this.dateFrom = new Date(start.toISOString());
        this.dateTo = new Date(end.toISOString());
        this.onChangeCallback();
    }

    /** start and end are moment instances. moment library not imported properly (in theme files) */
    private setDateRangeDisplay(start: any, end: any) {
        const today = new Date();
        const startDate = new Date(start.toISOString());
        const endDate = new Date(end.toISOString());
        this.$el.find("span").html(formatStart() + ' - ' + formatEnd());

        function formatStart() {
            if (startDate.getFullYear() === today.getFullYear()) {
                return start.format('MMMM D, hh:mm A');
            }

            return start.format('MMMM D, YYYY hh:mm A');
        }

        function formatEnd() {
            if (endDate.getFullYear() == startDate.getFullYear()
                && endDate.getMonth() == startDate.getMonth()
                && endDate.getDate() == startDate.getDate()) {
                return end.format('hh:mm A');
            }

            if (endDate.getFullYear() === today.getFullYear()) {
                return end.format('MMMM D, hh:mm A');
            }

            return end.format('MMMM D, YYYY hh:mm A');
        }
    }
}
